export const UK_LOCATIONS = {
    london: {
        country: 'UK',
        region: 'London',
    },
    manchester: {
        country: 'UK',
        region: 'Manchester',
    },
    birmingham: {
        country: 'UK',
        region: 'Birmingham',
    },
    liverpool: {
        country: 'UK',
        region: 'Liverpool',
    },
    leeds: {
        country: 'UK',
        region: 'Leeds',
    },
    northWestEngland: {
        country: 'UK',
        region: 'North West England',
    },
    northEastEngland: {
        country: 'UK',
        region: 'North East England',
    },
    yorkshireAndHumber: {
        country: 'UK',
        region: 'Yorkshire & Humber',
    },
    eastMidlands: {
        country: 'UK',
        region: 'East Midlands',
    },
    westMidlands: {
        country: 'UK',
        region: 'West Midlands',
    },
    southWestEngland: {
        country: 'UK',
        region: 'South West England',
    },
    southEastEngland: {
        country: 'UK',
        region: 'South East England',
    },
} as const;

export type UKRegion = keyof typeof UK_LOCATIONS; 